<template>
    <rkm-overlay>
        <rkm-layout-body title="Reabertura de viagem">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/reabertura-viagem/List'

export default {
    components: { List },
}
</script>